import classNames from "classnames";
import {
  IMAGE_RESOURCE_TYPE,
  VIDEO_RESOURCE_TYPE,
} from "../../views/Board/constants.ts";
import type { ResourceType } from "../../views/Board/types.ts";
import { BaseImage } from "./BaseImage.tsx";
import { BaseVideo } from "./BaseVideo.tsx";

export const ThumbnailContent = ({
  resourceType,
  className,
  src,
  cover = true,
}: {
  resourceType: ResourceType;
  className?: string;
  src?: string | null;
  cover?: boolean;
}) => {
  const contentClassName = classNames(
    "w-full h-full",
    cover ? "object-cover" : "object-contain",
  );
  switch (resourceType) {
    case IMAGE_RESOURCE_TYPE:
      return (
        <BaseImage
          imageClassName={contentClassName}
          className={classNames(className, "w-full h-full")}
          src={src}
          loading="lazy"
        />
      );
    case VIDEO_RESOURCE_TYPE:
      return (
        <BaseVideo
          videoClassName={contentClassName}
          className={classNames(className, "w-full h-full")}
          src={src}
        />
      );
  }
};
